import React, { useState } from 'react';
import { Input, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { SearchOutlined } from '@ant-design/icons';

import { MasterConfigs } from '../../../../../../interfaces/entity';
import ReusableTable from '../../../../../../components/TableComponent';



interface BDERecord {
  _id: string;
  name: string;
  code: string;
  target: number;
  achieved: number;
  performance: number;
  revenue: number;
}


const performanceTag = (value: number) => {
  if (value >= 100) return <Tag color="green">{value}%</Tag>;
  if (value >= 70) return <Tag color="orange">{value}%</Tag>;
  return <Tag color="red">{value}%</Tag>;
};



const BDEPerformanceTable: React.FC = () => {
  const [search, setSearch] = useState('');



  const tableConfig: MasterConfigs = {
    api: () => '/bde-performance',

    loadPagination: true,

    queryParams: {
      search,
    },

  
    renderComponent: () => (
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-sm font-semibold">BDE Performance</h3>
        <Input
          size="small"
          placeholder="Search"
          prefix={<SearchOutlined />}
          className="w-56"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
      </div>
    ),

 
    getColumns: (): ColumnsType<BDERecord> => [
      {
        title: 'BDE Name',
        dataIndex: 'name',
        render: (_, record) => (
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-gray-200 flex items-center justify-center text-xs font-semibold">
              {record.name.charAt(0)}
            </div>
            <div>
              <div className="text-sm font-medium">{record.name}</div>
              <div className="text-xs text-gray-400">{record.code}</div>
            </div>
          </div>
        ),
      },
      {
        title: 'Target (₹)',
        dataIndex: 'target',
        align: 'right',
        render: (v: number) => v.toLocaleString(),
      },
      {
        title: 'Achieved (₹)',
        dataIndex: 'achieved',
        align: 'right',
        render: (v: number) => v.toLocaleString(),
      },
      {
        title: 'Performance',
        dataIndex: 'performance',
        align: 'center',
        render: performanceTag,
      },
      {
        title: 'Revenue (₹)',
        dataIndex: 'revenue',
        align: 'right',
        render: (v: number) => v.toLocaleString(),
      },
      {
        title: 'Action',
        align: 'center',
        render: () => (
          <span className="text-blue-600 cursor-pointer text-sm">
            View
          </span>
        ),
      },
    ],

    tableProps: {
      bordered: true,
    },
  };



  return (
    <div className="bg-white p-4 rounded-md mt-6 pb-[50px]">
      <ReusableTable<BDERecord> config={tableConfig} />
    </div>
  );
};

export default BDEPerformanceTable;
